import { useEffect, useRef, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { getLandmarkByNodeId, getLandmarkByQr, getQrDetail, signin } from "../services/api"
import { Backdrop, Box, Card, CardContent, CircularProgress, Grid, styled, Typography } from '@mui/material'

import call from '../assets/call.svg'
import mail from '../assets/mail.svg'
import web from '../assets/web.svg'
import { clockTransform, runningStatus } from "./constants"
import Shimmer from "./Shimmer"
import { useSpeechSynthesis } from 'react-speech-kit';
import { decrypt } from "../services/decryption"


const Contacts = styled('div')({
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'flex-start'
})

const Contact = styled('div')({
    display: 'flex',
    gap: 18,
    alignItems: 'flex-start'
})

const ContactWrap = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
})

const Component = styled('div')({
    padding: 24,
    width: '100%',
    boxSizing: 'border-box'
})
const TitleBx = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 6
})
const Name = styled('p')({
    fontSize: 33,
    margin: 0,
    fontWeight: 500,
    lineHeight: '32px'
})
const Floor = styled('p')({
    color: '#777',
    fontSize: 24,
    lineHeight: '24px',
    fontWeight: 400,
    margin: 0
})
const Venue = styled('p')({
    color: '#777',
    fontSize: 21,
    fontWeight: 400,
    lineHeight: '20px',
    margin: 0
})
const Label = styled('p')({
    color: '#6C757D',
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '16px',
    margin: 0
})
const Value = styled('a')({
    color: '#065AA5',
    fontSize: 24,
    fontWeight: 400,
    lineHeight: '24px',
    margin: 0
})

const TimeStamp = styled('p')({
    color: '#777',
    fontSize: 24,
    fontWeight: 400,
    lineHeight: '24px',
    margin: 0
})
const Footer = styled('div')({
    background: '#FFF',
    boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
    padding: 24,
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0
})
const ContinueBtn = styled('button')({
    display: 'flex',
    padding: '8px 16px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 27,
    background: '#6CC8BF',
    height: 36,
    width: '100%',
    color: '#FFF',
    fontSize: 21,
    fontWeight: 500,
    lineHeight: '140%' /* 19.6px */
})


const Code = () => {

    const { code } = useParams()
    // const { speak, voices } = useSpeechSynthesis();
    // const [spoken, setSpoken] = useState(false)
    const [loading, setLoading] = useState(false)

    const nameRef = useRef()



    const [landmark, setLandmark] = useState()
    const [building, setBuilding] = useState()



    useEffect(() => {
        fetchData()
    }, [])



    let encryptionKey = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_ENCRYPTION_KEY : process.env.REACT_APP_REMOTE_ENCRYPTION_KEY
    let baseUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_URL : process.env.REACT_APP_REMOTE_URL


    let creds = {
        username: process.env.REACT_APP_USERNAME,
        password: process.env.REACT_APP_PASSWORD
    }

    creds = { encryptedData: decrypt(JSON.stringify(creds), encryptionKey) }



    // IIT%20Delhi/sorce%20polyid/accesstoken

    const fetchData = async () => {
        setLoading(true)
        if (window.location.href.includes("dev.iwayplus.in")) {
            // let response = await signin(creds, true)
            let qrDetail = await getQrDetail(code)
            if (qrDetail?.data?.redirectUrl && qrDetail?.data?.redirect) {
                window.location.replace(qrDetail?.data?.redirectUrl)

            }
            if (qrDetail.data.landmarkId) {
                let landmarkDetail = await getLandmarkByNodeId(qrDetail.data.landmarkId)
                landmarkDetail.data.venueName = landmarkDetail?.data?.venueName === "Ashoka Campus" ? "Ashoka University" : landmarkDetail?.data?.venueName
                if (landmarkDetail.data.venueName.includes("Ashoka")) setLandmark({ ...landmarkDetail.data, qr: qrDetail })

            }
            else {
                setLandmark({ qr: qrDetail.data })
            }

        }
        else {
            let landmarkDetail = await getLandmarkByQr(code)
            if (landmarkDetail?.data?.qr?.redirectUrl && landmarkDetail?.data?.qr?.redirect) {
                window.location.replace(landmarkDetail?.data?.qr?.redirectUrl);
                return
            }
            setLandmark(landmarkDetail.data)
            setBuilding(landmarkDetail.data.building)
            // let response = await signin(creds, true)
            landmarkDetail.data.venueName = landmarkDetail?.data?.venueName === "Ashoka Campus" ? "Ashoka University" : landmarkDetail?.data?.venueName
            // if(response.status === 200) {
            //     window.location.href = process.env.REACT_APP_FLUTTER_WEB+`/${landmarkDetail?.data?.venueName}/${landmarkDetail?.data?.properties?.polyId || landmarkDetail?.data?._id}/${response?.data?.accessToken}`
            // }

        }
        setLoading(false)
    }

    const handleClickApp = () => {
        if (building?.deeplinkUrl && building?.appId && building?.appStoreId) {
            window.location.href =
                `/#/iway-apps/${building?.deeplinkUrl}/landmark?bid=${landmark?.building_ID}&landmark=${landmark?.properties.polyId || landmark._id}&appStore=${building?.appStoreId}&playStore=${building?.playStoreId}`
        }
        else if (landmark.building_ID === "66ffc655cc539c610889cb98") {
            window.location.href =
                `/#/iway-apps/empower.com/landmark?bid=${landmark?.building_ID}&landmark=${landmark?.properties.polyId || landmark._id}&appStore=empower-2024/id6736653512&playStore=com.iwayplus.empower24`
        }
        else {
            window.location.href = `/#/iway-apps/ashoka.com/landmark?bid=${landmark?.building_ID}&landmark=${landmark?.properties.polyId || landmark._id}&appStore=accessible-ashoka/id6553976574&playStore=com.iwayplus.accessibleashoka`
        }

    }


    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            gap: '16px',
            fontFamily: 'system-ui, -apple-system, sans-serif',
        },
        spinner: {
            width: '40px',
            height: '40px',
            border: '4px solid #e5e7eb',
            borderTopColor: '#3b82f6',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
        },
        text: {
            fontSize: '16px',
            fontWeight: 600,
            color: '#111827',
            margin: 0,
        },
        subtext: {
            fontSize: '14px',
            color: '#6b7280',
            margin: 0,
        },
    };

    if (!landmark) return <Shimmer />
    // if (!landmark?.name || landmark?.message === "qr cannot be found") return <h2>Oops! Cannot Find Any landmark for the qr {code} </h2>

    if (landmark?.qr?.redirect) {
        return (
            <div style={styles.container}>
                <div style={styles.spinner} />
                <p style={styles.text}>Redirecting you...</p>
                <p style={styles.subtext}>Hang tight, this will just take a moment</p>
            </div>
        );
    }


    return (
        <div>
            <Component>
                {landmark?.name && <TitleBx>
                    <ContinueBtn style={{ cursor: 'unset' }} ref={nameRef}  >{landmark?.name}</ContinueBtn>
                    {/* <button style={{ float: 'right', cursor: 'pointer' }} onClick={() => speak({ text: `You are at ${landmark.name} on Floor ${landmark.floor}`, voice: voices[0] })}>🔊</button> */}
                    <Floor>Floor {landmark?.floor}, {landmark?.buildingName}</Floor>
                    <Venue>{landmark?.venueName}</Venue>
                    {
                        landmark?.properties?.startTime &&
                        landmark?.properties?.endTime &&
                        <TimeStamp>
                            {clockTransform(landmark?.properties?.startTime)} - {clockTransform(landmark?.properties?.endTime)}
                            <span style={{
                                color: runningStatus(landmark?.properties?.startTime, landmark?.properties?.endTime) === true ? "#4CAF50" : "#f00"
                            }}>{runningStatus(landmark?.properties?.startTime, landmark?.properties?.endTime) === true ? " Open Now" : " Closed"}</span>
                        </TimeStamp>}
                </TitleBx>}
                {
                    (
                        landmark?.properties?.contactNo ||
                        landmark?.properties?.phone ||
                        landmark?.properties?.email ||
                        landmark?.properties?.url ||
                        landmark?.building?.website
                    ) &&
                    <Contacts>
                        <h3>Contact Details</h3>
                        {(landmark?.properties?.contactNo || landmark?.properties?.phone) && <Contact>
                            <img alt="" src={call} />
                            <ContactWrap>
                                <Label>Phone</Label>
                                <Value href={`tel:${landmark?.properties?.contactNo || landmark?.building?.phone}`}>
                                    {landmark?.properties?.contactNo || landmark?.properties?.phone}
                                </Value>
                            </ContactWrap>
                        </Contact>}
                        {landmark?.properties?.email && <Contact>
                            <img src={mail} />
                            <ContactWrap>
                                <Label>E-Mail</Label>
                                <Value href={`mailto:${landmark?.properties?.email}`}>
                                    {landmark?.properties?.email}
                                </Value>
                            </ContactWrap>
                        </Contact>}
                        {(landmark?.properties?.url || landmark?.building?.website) && <Contact>
                            <img src={web} />
                            <ContactWrap>
                                <Label>Website</Label>
                                <Value target="_blank" href={landmark?.properties?.url || landmark?.building?.website}>
                                    {landmark?.properties?.url || landmark?.building?.website}
                                </Value>
                            </ContactWrap>
                        </Contact>}


                    </Contacts>}
                {/* <div>
                photos
            </div> */}

                <Card
                    sx={{
                        maxWidth: 500,
                        mx: "auto",
                        mt: 2,
                        borderRadius: 3,
                        boxShadow: 3
                    }}
                >
                    <CardContent>
                        <Box display="flex" flexDirection="column" gap={2}>

                            {/* Description */}
                            {landmark?.qr?.text && (
                                <Typography variant="body1" color="text.primary">
                                    {landmark.qr.text}
                                </Typography>
                            )}

                            {/* URL */}
                            {landmark?.qr?.redirectUrl && (
                                <Link
                                    href={landmark.qr.redirectUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    underline="hover"
                                    sx={{ wordBreak: "break-all" }}
                                >
                                    {landmark.qr.redirectUrl}
                                </Link>
                            )}

                            {/* Media Section */}
                            {landmark?.qr?.media?.length > 0 && (
                                <Grid container spacing={2}>
                                    {landmark.qr.media.map((elm, idx) => {
                                        const src = `${baseUrl}/uploads/${elm.originalname}`;

                                        return (
                                            <Grid item xs={6} key={idx}>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        borderRadius: 2,
                                                        overflow: "hidden",
                                                        transition: "0.3s",
                                                        "&:hover": {
                                                            transform: "scale(1.05)",
                                                        },
                                                    }}
                                                >
                                                    {/* IMAGE */}
                                                    {elm?.mimetype?.startsWith("image/") && (
                                                        <Box
                                                            component="img"
                                                            src={src}
                                                            alt="media"
                                                            sx={{
                                                                width: "100%",
                                                                height: 140,
                                                                objectFit: "cover",
                                                                display: "block",
                                                            }}
                                                        />
                                                    )}

                                                    {/* VIDEO */}
                                                    {elm?.mimetype?.startsWith("video/") && (
                                                        <Box
                                                            component="video"
                                                            src={src}
                                                            controls   // IMPORTANT
                                                            muted
                                                            sx={{
                                                                width: "100%",
                                                                height: 140,
                                                                objectFit: "cover",
                                                                display: "block",
                                                            }}
                                                        />
                                                    )}

                                                    {/* AUDIO */}
                                                    {elm?.mimetype?.startsWith("audio/") && (
                                                        <Box
                                                            sx={{
                                                                height: 140,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                p: 2,
                                                            }}
                                                        >
                                                            <audio src={src} controls style={{ width: "100%" }} />
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            )}

                        </Box>
                    </CardContent>
                </Card>

            </Component>
            <Footer>
                <ContinueBtn onClick={handleClickApp}>
                    Continue to App
                </ContinueBtn>
            </Footer>
            <Backdrop open={loading}>
                <CircularProgress />
            </Backdrop>
        </div>
    )
}

export default Code